(function () {
  function init() {
    var container = document.querySelector('.product__info-container');
    if (!container) return;
    var accordions = container.querySelectorAll(':scope > .accordion');
    if (accordions.length < 2) return;
    if (container.querySelector('.pdp-tabs-wrapper')) return;
    var wrapper = document.createElement('div');
    wrapper.className = 'pdp-tabs-wrapper';
    var btnRow = document.createElement('div');
    btnRow.className = 'pdp-tabs-buttons';
    btnRow.setAttribute('role', 'tablist');
    var panelsRow = document.createElement('div');
    panelsRow.className = 'pdp-tabs-panels';
    wrapper.appendChild(btnRow);
    wrapper.appendChild(panelsRow);
    Array.prototype.forEach.call(accordions, function (acc, idx) {
      var titleEl = acc.querySelector('.accordion-title');
      var panelEl = acc.querySelector('.accordion-panel');
      if (!titleEl || !panelEl) return;
      var titleText = (titleEl.textContent || '').replace(/\s+/g, ' ').trim();
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pdp-tab-button' + (idx === 0 ? ' active' : '');
      btn.textContent = titleText;
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-selected', idx === 0 ? 'true' : 'false');
      btn.setAttribute('data-pdp-tab-idx', String(idx));
      btnRow.appendChild(btn);
      var panel = document.createElement('div');
      panel.className = 'pdp-tab-panel' + (idx === 0 ? ' active' : '');
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('data-pdp-tab-idx', String(idx));
      while (panelEl.firstChild) panel.appendChild(panelEl.firstChild);
      panelsRow.appendChild(panel);
      acc.classList.add('pdp-tabs-hidden');
    });
    accordions[0].parentNode.insertBefore(wrapper, accordions[0]);
    btnRow.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.pdp-tab-button');
      if (!btn) return;
      var idx = btn.getAttribute('data-pdp-tab-idx');
      Array.prototype.forEach.call(btnRow.querySelectorAll('.pdp-tab-button'), function (b) {
        var isActive = b === btn;
        b.classList.toggle('active', isActive);
        b.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      Array.prototype.forEach.call(panelsRow.querySelectorAll('.pdp-tab-panel'), function (p) {
        p.classList.toggle('active', p.getAttribute('data-pdp-tab-idx') === idx);
      });
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();


/* PDP TWEAK 3: Size chart default unit = Inches */
(function () {
  function clickInchesIfNeeded() {
    var modal = document.querySelector('#jsc-overlay, .jsc-modal');
    if (!modal) return false;
    var buttons = modal.querySelectorAll('button');
    var cm = null, inch = null;
    buttons.forEach(function (b) { var t = (b.textContent || '').trim().toUpperCase(); if (t === 'CM') cm = b; if (t === 'IN' || t === 'INCH' || t === 'INCHES') inch = b; });
    if (cm && inch && cm.classList.contains('jsc-active') && !inch.classList.contains('jsc-active')) { inch.click(); return true; }
    return false;
  }
  function watch() {
    var trigger = document.querySelector('#jsc-trigger-button, .jsc-size-chart-button');
    if (!trigger) { setTimeout(watch, 500); return; }
    trigger.addEventListener('click', function () { var attempts = 0; var iv = setInterval(function () { if (clickInchesIfNeeded() || ++attempts > 30) clearInterval(iv); }, 100); });
    var mo = new MutationObserver(function () { var modal = document.querySelector('#jsc-overlay, .jsc-modal'); if (modal && modal.offsetParent !== null) { setTimeout(clickInchesIfNeeded, 80); } });
    mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style','class','hidden'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();


/* ===== PDP TWEAK 4: Floating sticky Add-to-Cart button (bottom-right) ===== */
(function () {
  function init() {
    var mainBtn = document.querySelector('button.product-form__submit, [name="add"]');
    if (!mainBtn) return;
    if (document.querySelector('.pdp-sticky-atc-fab')) return;
    var fab = document.createElement('button');
    fab.type = 'button';
    fab.className = 'pdp-sticky-atc-fab';
    fab.setAttribute('aria-label', 'Add to cart');
    fab.innerHTML = '<svg class="pdp-sticky-atc-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 3h2l2.4 12.5a2 2 0 0 0 2 1.5h9.3a2 2 0 0 0 2-1.6L22 8H6"/><circle cx="9" cy="21" r="1"/><circle cx="19" cy="21" r="1"/></svg><span class="pdp-sticky-atc-text">Add to Cart</span>';
    fab.addEventListener('click', function (e) { e.preventDefault(); if (!mainBtn.disabled) { mainBtn.click(); } else { mainBtn.scrollIntoView({ behavior: 'smooth', block: 'center' }); } });
    document.body.appendChild(fab);
    function syncLabel() { var t = (mainBtn.textContent || '').replace(/\s+/g, ' ').trim(); var sold = /sold\s*out|unavailable/i.test(t); fab.querySelector('.pdp-sticky-atc-text').textContent = sold ? t : 'Add to Cart'; fab.classList.toggle('is-disabled', !!mainBtn.disabled); fab.disabled = mainBtn.disabled; }
    syncLabel();
    var labelObs = new MutationObserver(syncLabel);
    labelObs.observe(mainBtn, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['disabled','aria-disabled'] });
    var io = new IntersectionObserver(function (entries) { entries.forEach(function (en) { fab.classList.toggle('is-visible', !en.isIntersecting); }); }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });
    io.observe(mainBtn);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
